import * as Mui from "@mui/material";
import styled from "@emotion/styled";
import { customTheme } from "../../../../config/theme/MuiTheme";

const Stack = styled(Mui.Stack)({
  backgroundColor: customTheme.palette.neutral.bright,
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
});

const StyledMui = {
  Stack,
}

export default StyledMui;